"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popoverPropTypes = exports.popoverControllerPropTypes = exports.popoverCallbacksPropTypes = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _propTypes = require("../prop-types");
var _utils = require("../utils");
var _interfaces = require("./interfaces");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var PopoverOffsetPropsPropTypes = {
  'top-leading': _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.number),
  'top-center': _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.number),
  'top-trailing': _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.number),
  'bottom-leading': _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.number),
  'bottom-center': _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.number),
  'bottom-trailing': _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.number)
};
var popoverPropTypes = {
  'aria-haspopup': _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.bool]).description("Sets the 'aria-haspopup' property on the trigger button."),
  children: _stencilReactDesc.PropTypes.func.isRequired.description('Function which returns content to be displayed in the popover.').format("({\n  close: () => void\n}) => React.ReactNode"),
  contentProps: _stencilReactDesc.PropTypes.object.description('Props to pass to the content container.'),
  maxWidth: (0, _propTypes.cssValue)().description("Sets the CSS 'max-width' property on the popover content."),
  onOpened: _stencilReactDesc.PropTypes.func.description('Function called once the popover has finished opening.').format('() => void'),
  onClosed: _stencilReactDesc.PropTypes.func.description('Function called once the popover has finished closing.').format('() => void'),
  offset: _stencilReactDesc.PropTypes.shape(_objectSpread({}, PopoverOffsetPropsPropTypes)).description('Sets the offset to displace popper element from its trigger element. First element of array is for skidding and second element of array is for distance'),
  position: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.PopoverPosition)).description('The position of the popover relative to the trigger button.'),
  shouldCloseOnFocusLeave: _stencilReactDesc.PropTypes.bool.description('Whether the popover should close when focus moves outside its body.'),
  shouldFocusOnOpen: _stencilReactDesc.PropTypes.bool.description('Whether the popover body should gain focus when opened.'),
  shouldOverflow: _stencilReactDesc.PropTypes.bool.description('Whether the popover should overflow the viewport.'),
  triggerButtonProps: _stencilReactDesc.PropTypes.object.description('Props to pass to the trigger button.'),
  triggerText: _stencilReactDesc.PropTypes.string.isRequired.description('Text to display in the trigger button.')
};
exports.popoverPropTypes = popoverPropTypes;
var popoverCallbacksPropTypes = _objectSpread(_objectSpread({}, (0, _utils.pick)(popoverPropTypes, ['onOpened'])), {}, {
  onClosed: _stencilReactDesc.PropTypes.func.description('Function called once the popover has finished closing.').format('() => void')
});
exports.popoverCallbacksPropTypes = popoverCallbacksPropTypes;
var popoverControllerPropTypes = _objectSpread(_objectSpread(_objectSpread({}, popoverCallbacksPropTypes), (0, _utils.pick)(popoverPropTypes, ['shouldCloseOnFocusLeave', 'shouldFocusOnOpen'])), {}, {
  children: _stencilReactDesc.PropTypes.node.description('Content to display inside the popover.'),
  close: _stencilReactDesc.PropTypes.func.isRequired.description('Function called when the user performs an action which should close the popover.'),
  isOpen: _stencilReactDesc.PropTypes.bool.description('Whether the popover is currently open.'),
  position: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.PopoverPosition)).description('The position of the popover relative to the reference element.'),
  target: _stencilReactDesc.PropTypes.any.isRequired.description('A ref to the element the popover should be visually attached to.')
});
exports.popoverControllerPropTypes = popoverControllerPropTypes;